import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { CGU_TITLE, CGU_VERSION, CGU_TEXT, ML_TITLE, ML_VERSION, ML_TEXT } from "../lib/legalDocs";

// Rendu d'un document légal : "## " = titre de section, "### " = sous-titre, "- " = puce.
function renderDoc(text) {
  const blocks = [];
  let list = null;
  const flush = () => {
    if (list) {
      blocks.push(
        <ul key={blocks.length} className="my-3 list-disc space-y-1.5 pl-6 text-sm leading-relaxed text-ink-secondary marker:text-cyan">
          {list.map((li, i) => <li key={i}>{li}</li>)}
        </ul>
      );
      list = null;
    }
  };
  text.split("\n").forEach((line) => {
    const l = line.trim();
    if (!l) { flush(); return; }
    if (l.startsWith("## ")) {
      flush();
      blocks.push(
        <h2 key={blocks.length} className="mt-10 border-l-2 border-cyan pl-4 font-display text-lg font-700 text-white">
          {l.slice(3)}
        </h2>
      );
    } else if (l.startsWith("### ")) {
      flush();
      blocks.push(
        <h3 key={blocks.length} className="mt-6 pl-4 text-sm font-700 uppercase tracking-wider text-cyan">
          {l.slice(4)}
        </h3>
      );
    } else if (l.startsWith("- ")) {
      if (!list) list = [];
      list.push(l.slice(2));
    } else {
      flush();
      blocks.push(
        <p key={blocks.length} className="mt-3 pl-4 text-sm leading-relaxed text-ink-secondary">{l}</p>
      );
    }
  });
  flush();
  return blocks;
}

export default function Legal({ doc }) {
  const isCgu = doc === "cgu";
  const title = isCgu ? CGU_TITLE : ML_TITLE;
  const text = isCgu ? CGU_TEXT : ML_TEXT;
  const other = isCgu
    ? { to: "/mentions-legales", label: "Mentions légales" }
    : { to: "/cgu", label: "Conditions Générales d'Utilisation" };

  return (
    <div>
      <Seo title={`${title} — APP CHALLENGE ACADEMY`} description={`${title} d'APP CHALLENGE ACADEMY — version en vigueur septembre 2026.`} />
      <main className="mx-auto max-w-4xl px-5 pt-12 pb-20">
        <div className="text-[11px] uppercase tracking-[0.25em] text-cyan">APP CHALLENGE ACADEMY</div>
        <h1 className="mt-3 font-display text-3xl font-900 text-white sm:text-4xl" data-testid="legal-title">{title}</h1>
        <p className="mt-2 text-xs uppercase tracking-widest text-ink-tertiary" data-testid="legal-version">
          {isCgu ? CGU_VERSION : ML_VERSION} · Rentrée APP CHALLENGE ACADEMY 2026-2027
        </p>
        <p className="mt-4 text-sm text-ink-secondary">
          Document lié :{" "}
          <Link to={other.to} className="text-cyan underline-offset-2 hover:underline" data-testid="legal-other">
            {other.label}
          </Link>
        </p>

        <div className="mt-8 rounded-2xl border border-white/10 bg-surface p-6 sm:p-10" data-testid="legal-content">
          {renderDoc(text)}
        </div>

        <div className="mt-10 rounded-xl border border-white/10 bg-surface p-6 text-sm leading-relaxed text-ink-secondary">
          <div className="mb-2 font-display text-base font-700 text-white">APP CHALLENGE ACADEMY by ECO EVENT</div>
          ECO EVENT SARL — 78 avenue des Champs-Élysées, 75008 Paris – France<br />
          SIREN / RCS Paris : 799 853 148 · TVA : FR34 799 853 148<br />
          E-mail : <a href="mailto:contact@appchallengeacademy.com" className="text-cyan underline-offset-2 hover:underline">contact@appchallengeacademy.com</a> · Site : appchallengeacademy.com
        </div>
      </main>
    </div>
  );
}
